module.exports = __webpack_public_path__ + "img/link_gczjj.058393e6.png";